import React from 'react';
import ImageLoader from '../images/ImageLoader';
import Parallax from 'react-rellax';

var BackgroundItem = function BackgroundItem(_ref) {
  var speed = _ref.speed,
      image = _ref.image,
      position = _ref.position;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "cb-background__item",
    style: position
  }, /*#__PURE__*/React.createElement(Parallax, {
    speed: speed
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    loadEagerly: true,
    media: {
      'value': {
        'src': image
      }
    }
  }))));
};

export default BackgroundItem;